import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Link } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import ServicePage from "@/pages/ServicePage";
import Residential from "@/pages/Residential";
import ForBrokers from "@/pages/ForBrokers";
import QuotePage from "@/pages/QuotePage";
import ThankYou from "@/pages/ThankYou";
import { track } from "@/lib/api";

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    track("page_view", pathname + hash);
    const lenis = window.__lenis;
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        setTimeout(() => {
          if (lenis) lenis.scrollTo(el, { offset: -90 });
          else el.scrollIntoView();
        }, 80);
        return;
      }
    }
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function MobileCTA() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/request") || pathname.startsWith("/thank-you")) return null;
  return (
    <div className="fixed bottom-0 inset-x-0 z-40 md:hidden grid grid-cols-2 border-t border-ink/15 bg-paper" data-testid="mobile-cta-bar">
      <Link to="/request-quote" data-testid="mobile-bar-quote-button" className="py-4 text-center font-semibold uppercase tracking-widest text-xs bg-ink text-paper">
        Get a Quote
      </Link>
      <Link to="/request-site-visit" data-testid="mobile-bar-visit-button" className="py-4 text-center font-semibold uppercase tracking-widest text-xs text-ink">
        Site Visit
      </Link>
    </div>
  );
}

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollManager />
        <Nav />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services/:slug" element={<ServicePage />} />
          <Route path="/residential" element={<Residential />} />
          <Route path="/for-brokers" element={<ForBrokers />} />
          <Route path="/request-quote" element={<QuotePage mode="quote" />} />
          <Route path="/request-site-visit" element={<QuotePage mode="site_visit" />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="*" element={<Home />} />
        </Routes>
        <Footer />
        <MobileCTA />
        <Toaster position="top-center" />
      </BrowserRouter>
    </div>
  );
}
